// import React from 'react'
// import AuditFormAnswerFieldUi from './AuditFormAnswerFieldUi'

// function AuditFormAnswerField({values,formik,index,subQuestion,handleSubQuestionChange}) {
//   return (
//     <AuditFormAnswerFieldUi values={values} formik={formik} index={index} subQuestion={subQuestion} handleSubQuestionChange={handleSubQuestionChange}/>
//   )
// }

// export default AuditFormAnswerField

import React from "react";
import AuditFormAnswerFieldUi from "./AuditFormAnswerFieldUi";

function AuditFormAnswerField({ values, index, subIndex, subQuestion,boxes,setBoxes,error,setError,validateQuestions }) {
  return (
    <AuditFormAnswerFieldUi
      values={values}
      index={index}
      subIndex={subIndex}
      subQuestion={subQuestion}
      setBoxes={setBoxes}
      boxes={boxes}
      error={error}
      setError={setError}
      validateQuestions={validateQuestions}
    />
  );
}

export default AuditFormAnswerField;
